import React from "react";

export default function TruncationBanner({ pageViewsTruncated, requestsTruncated }) {
  if (!pageViewsTruncated && !requestsTruncated) return null;

  return (
    <div
      className="alert alert-warning mb-2"
      style={{ padding: "0.5rem 0.75rem", fontSize: "0.875rem" }}
      role="alert"
    >
      Some activity rows were omitted for this date range (server cap reached).
      Narrow the range for a complete view.
    </div>
  );
}
